let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5jrmX"), load("1pG9q")]).then(() => parcelRequire('99jPR'));